;(function($){

    function Panel_revenues() {
        var _            = this;  
        var data         = new FormData();
        _.oScheduleTime  = $("input[name='schedule_time[]']");
        _.hours          = 0.00;
        _.hours_charged  = 0.00;
        _.value_analyst  = 0.00;
        _.value_charge   = 0.00;
        _.total_taxation = 0.00;
        _.total_costs    = 0.00;
        _.total_value    = 0.00;
        _.total_average  = 0.00;

        if($("#modal-panel-revenues").length > 0) {

            $("#modal-panel-revenues").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();  
                    _.html = '<form id="form-panel-revenues">'+
                        '<div class="row">' +
                            '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="filter_send_billets">Enviar Boletos?</label>' +
                                    '<select name="filter_send_billets" id="filter_send_billets">'+
                                    '<option value="0">Não</option>'+
                                    '<option value="1">Sim</option>'+
                                    '</select>' +
                                '</div>'+
                            '</div>'+
                            '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="filter_send_nfse">Enviar NFSE?</label>' +
                                    '<select name="filter_send_nfse" id="filter_send_nfse">'+
                                    '<option value="0">Não</option>'+
                                    '<option value="1">Sim</option>'+
                                    '</select>' +
                                '</div>'+
                            '</div>'+                             
                       '</div>'+
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<button class="pull-right btn-primary btn-send">OK <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                            
                       '</div>'+
                   '</form>';
                    $('#modal-panel-revenues').iziModal('setTitle', '<i class="fa fa-money" aria-hidden="true"></i> Paramentros de Faturamento');
                    $("#modal-panel-revenues .content").html(_.html);

                    _.myForm = $("#form-panel-revenues").validate({
                        rules: {
                            filter_send_billets: { required: true },
                            filter_send_nfse: { required: true }
                        },
                        messages: {
                            filter_send_billets: { required: "Campo Obrigatório" },
                            filter_send_nfse: { required: "Campo Obrigatório" }
                        },
                        invalidHandler: function(e) {
                            swal({
                                title: "Atenção!",
                                text: "Confirme os paramentros",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                            window.location.href = _.url+"&"+$('#form-panel-revenues').serialize(); 
                        }
                    });             
                },
                onClosed: function() {
                    _.uri          = null;
                    _.html         = null;
                    $("#modal-panel-revenues .content").html("");
                    $('#modal-panel-revenues').iziModal('setTitle', "");
                    
                }        
            });

            $("a.btn-panel-revenues, a.btn-agglutinate").on("click", function(e){
                e.preventDefault();
                _.url           = $(this).attr('href');
                $('#modal-panel-revenues').iziModal('open');           
            });

            $("input#scheduleTimeAll").on("change", function(e){
                $(this).is(':checked') ? _.checkAll() : _.UnCheckAll();
            });

            $("input[name='schedule_time[]']").on("change", function(e){

                if($("input[name='schedule_time[]']:checked").length == 0) {
                    window.location.reload(true);
                }
                
                _.total(this, $(this).is(':checked'));
            });
         
        }       
    } 

    Panel_revenues.prototype.checkAll = function() {
        var _ =  this;

        _.oScheduleTime.each(function( index, value) {
           $(value).prop('checked', true);
           _.total(value, true);
        });
    };

    Panel_revenues.prototype.UnCheckAll = function() {
        var _ =  this;

        _.oScheduleTime.each(function( index, value) {
           $(value).prop('checked', false);
           window.location.reload(true);
        });
    };

    Panel_revenues.prototype.total = function(item, isSum) {
        var _               =  this;
        var nhours          = 0;
        var nhours_charged  = 0;
        var nvalue_analyst  = 0;
        var nvalue_charge   = 0;
        var ntotal_taxation = 0;
        var ntotal_costs    = 0;
        var ntotal_value    = 0;
        var ntotal_average  = 0;
        var a_schedule_time = [];

        if (isSum) {
            _.hours          += $(item).data('hours-total');
            _.hours_charged  += $(item).data('hours-charged');
            _.value_analyst  += $(item).data('value-analyst');
            _.value_charge   += $(item).data('value-charge');
            _.total_taxation += $(item).data('total-taxation');
            _.total_costs    += $(item).data('total-costs');
        } else {
            _.hours          -= $(item).data('hours-total');
            _.hours_charged  -= $(item).data('hours-charged');
            _.value_analyst  -= $(item).data('value-analyst');
            _.value_charge   -= $(item).data('value-charge');
            _.total_taxation -= $(item).data('total-taxation');
            _.total_costs    -= $(item).data('total-costs');
        }
      
        _.total_value    = (_.value_charge - (_.value_analyst + _.total_taxation + _.total_costs));
        _.total_average  = (_.value_charge == 0) ? 0 : (_.value_charge /  _.hours_charged);

        nhours          =  _.hours;
        nhours_charged  =  _.hours_charged;
        nvalue_analyst  =  _.value_analyst;
        nvalue_charge   =  _.value_charge;
        ntotal_taxation =  _.total_taxation;
        ntotal_costs    =  _.total_costs;
        ntotal_value    =  _.total_value;
        ntotal_average  =  _.total_average;

        nhours          =  _.hours;
        nhours_charged  =  _.hours_charged;
        nvalue_analyst  =  _.value_analyst;
        nvalue_charge   =  _.value_charge;
        ntotal_taxation =  _.total_taxation;
        ntotal_costs    =  _.total_costs;
        ntotal_value    =  _.total_value;
        ntotal_average  =  _.total_average;


        nhours          =  nhours.toFixed(0);
        nhours_charged  =  nhours_charged.toFixed(0);
        nvalue_analyst  =  nvalue_analyst.toFixed(2);
        nvalue_charge   =  nvalue_charge.toFixed(2);
        ntotal_taxation =  ntotal_taxation.toFixed(2);
        ntotal_costs    =  ntotal_costs.toFixed(2);
        ntotal_value    =  ntotal_value.toFixed(2);
        ntotal_average  =  ntotal_average.toFixed(2);

        nhours          =  nhours;
        nhours_charged  =  nhours_charged;
        nvalue_analyst  =  nvalue_analyst.replace('.',',');
        nvalue_charge   =  nvalue_charge.replace('.',',');
        ntotal_taxation =  ntotal_taxation.replace('.',',');
        ntotal_costs    =  ntotal_costs.replace('.',',');
        ntotal_value    =  ntotal_value.replace('.',',');
        ntotal_average  =  ntotal_average.replace('.',',');

        $(".title-hours-total").text(nhours+" hs");
        $(".title-hours-charged").text(nhours_charged+" hs");
        $(".title-value-analyst").text(nvalue_analyst);
        $(".title-value-charge").text(nvalue_charge);
        $(".title-total-taxation").text(ntotal_taxation);
        $(".title-total-costs").text(ntotal_costs);
        $(".title-total-value").text(ntotal_value);
        $(".title-total-average").text(ntotal_average);


        $.each($("input[name='schedule_time[]']:checked"), function(idex, value) {
            a_schedule_time.push($(value).val());
        }); 

        $.each($("#links a"), function(idex, value) {
            var href  = new URL($(value).attr('href'));
            href.searchParams.set('a_schedule_time', a_schedule_time);
            $(value).attr('href', href);
        });        
    };


   	new Panel_revenues();

}(jQuery));